import React, { useEffect, useState } from "react";
import { DownloadSimple, X, Export } from "@phosphor-icons/react";

const DISMISS_KEY = "iefsc_install_dismissed";

export function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);

    // iOS Safari has no beforeinstallprompt — show a manual hint instead.
    const ua = window.navigator.userAgent;
    const isIOS = /iphone|ipad|ipod/i.test(ua);
    const isSafari = /^((?!chrome|crios|fxios|android).)*safari/i.test(ua);
    if (isIOS && isSafari) { setIosHint(true); setShow(true); }

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem(DISMISS_KEY, "1"); };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="install-pwa-banner"
      className="fixed z-50 left-4 right-4 bottom-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm border border-[#FF5722]/40 bg-[#121212] shadow-[0_10px_40px_rgba(0,0,0,0.6)] p-4 safe-bottom"
    >
      <button onClick={dismiss} data-testid="install-pwa-dismiss" aria-label="Dismiss" className="absolute top-2 right-2 text-white/40 hover:text-white transition-colors">
        <X size={18} />
      </button>
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 shrink-0 bg-[#FF5722] flex items-center justify-center">
          <DownloadSimple size={22} weight="bold" className="text-black" />
        </span>
        <div className="pr-4">
          <div className="font-display text-xl uppercase leading-tight">Install the app</div>
          {iosHint ? (
            <p className="text-white/60 text-sm mt-1">
              Tap <Export size={15} className="inline align-text-bottom" /> Share, then <strong className="text-white">Add to Home Screen</strong> for an app-like experience.
            </p>
          ) : (
            <>
              <p className="text-white/60 text-sm mt-1">Add IEFSC Basketball to your home screen for quick, full-screen access.</p>
              <button onClick={install} data-testid="install-pwa-btn" className="mt-3 bg-[#FF5722] hover:bg-[#FF7043] text-black font-bold uppercase tracking-wide text-sm px-5 py-2.5 transition-all duration-200">
                Install
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
